import React from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { animated, useSpring } from 'react-spring';

import Spinner from '../../../../shared/_TBComponents/Spinner';
import Text from '../../../../shared/_TBComponents/Text';

const LoadMoreContainer = styled('div')`
  display: flex;
  width: 100%;
  height: 60px;
  padding-bottom: 20px;
  padding-left: 15px;
  padding-right: 15px;
  justify-content: center;
  position: relative;
`;

const LoadMoreWrapper = () => {
  const isEndOfList = useSelector((state) => state.feed.data.isEndOfList);
  const isNextPageLoading = useSelector((state) => state.feed.ui.isNextPageLoading);
  const isFeedLoading = useSelector((state) => state.feed.ui.isFeedLoading);
  const isPinnedFeedLoading = useSelector((state) => state.feed.ui.isPinnedFeedLoading);
  const feed = useSelector((state) => state.feed.data.feed);
  const pinnedFeed = useSelector((state) => state.feed.data.pinnedFeed);
  const isFeedShowing = useSelector((state) => state.feed.data.isFeedShowing);
  const isTvMode = useSelector((state) => state.feed.data.isTvMode);

  const loadTransition = useSpring({
    position: 'absolute',
    opacity: isNextPageLoading ? 1 : 0,
  });

  const endTransition = useSpring({
    position: 'absolute',
    opacity: isEndOfList ? 1 : 0,
  });

  const isLoading = isFeedLoading || (isFeedShowing && isPinnedFeedLoading);
  const feedHasContent = !!feed.length || (isFeedShowing && !isTvMode && !!pinnedFeed?.length);

  return (
    <LoadMoreContainer>
      <animated.div style={loadTransition}>
        <Spinner
          saving
          darkTheme
        />
      </animated.div>
      {!isLoading && feedHasContent && (
        <animated.div style={endTransition}>
          <Text
            styledTextProps={{
              fontSize: 12,
              fontWeight: 900,
              letterSpacing: 1.3,
            }}
          >
            END OF FEED
          </Text>
        </animated.div>
      )}
    </LoadMoreContainer>
  );
};

export default LoadMoreWrapper;
